import { Controller } from 'stimulus';

export default class extends Controller {
  initialize() {
    this.listener = this._listener.bind(this);
  }

  connect() {
    document.addEventListener('form-validation-failure', this.listener);
    this.element.addEventListener('formifierInvalid', this.listener);
  }

  disconnect() {
    document.removeEventListener(
      'form-validation-failure',
      this.listener,
      true
    );
  }

  static targets = ['overlay', 'spinner'];

  start() {
    const className =
      this.data?.get('variant') === 'background'
        ? 'pro-Processing-overlay--background'
        : 'pro-Processing-overlay';

    this.overlayTarget.classList.add(className);
    this.spinnerTarget.classList.remove('u-displayNone');
  }

  stop() {
    this.overlayTarget.classList.remove('pro-Processing-overlay');
    this.overlayTarget.classList.remove('pro-Processing-overlay--background');
    this.spinnerTarget.classList.add('u-displayNone');
  }

  _listener(e) {
    if (e.detail?.triggerEvent?.currentTarget.closest('.pro-Modal')) {
      this.stop();
    } else if (e.target?.tagName === 'FORM') {
      this.stop();
    }
  }
}
